import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, {TableCell, TableRow, TableSectionHeader} from "@amzn/meridian/table";
import React from "react"
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close";
import check from "@amzn/meridian-tokens/base/icon/check-large"
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";
import {getPhoneToolLink} from "../util/Util";
import Tag from "@amzn/meridian/tag";
import Tooltip from "@amzn/meridian/tooltip";

const CartContent = (props) => {

    const getCartStatusColor = (cartStatus) => {
        switch (cartStatus) {
            case "Missing":
                return "error";
            case "Sidelined":
                return "error";
            case "Picked":
                return "warning";
            case "Ready":
                return "warning";
            case "Staged":
                return "success";
            case "Departed":
                return "success";
            default:
                return "neutral";
        }
    }

    return (
        <div>
            {/* CART LABEL */}
            <Row widths="100%" spacingInset="small none none">
                <Heading level={3} type="h500" alignment="left">{props.container.name}</Heading>
            </Row>

            {/* STAGE ASSOCIATE */}
            {!props.container.isNotInCart ?
                <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium none none">
                    <Text type="h100">
                        <FormattedMessage id="cartContent.stageAssociate" defaultMessage="Stage Associate"/>
                    </Text>
                    {props.container.stageAssociate !== '...' ?
                        <Link href={getPhoneToolLink(props.container.stageAssociate)} type="secondary" target="_blank"
                              rel="noreferrer noopener">
                            {props.container.stageAssociate}
                        </Link>
                        : "..."
                    }
                </Row>
                : null
            }

            {/*CART STATUS */}
            {!props.container.isNotInCart ?
                <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium none none">
                    <Text type="h100">
                        <FormattedMessage id="cartContent.cartStatus" defaultMessage="Status"/>
                    </Text>
                    <TableCell>
                        <Tooltip position="top" title={props.container.status}>
                            <Tag type={getCartStatusColor(props.container.status)}>{props.container.status.length > 11 ?
                                props.container.status.substr(0, 10) + "..." : props.container.status}</Tag>
                        </Tooltip>
                    </TableCell>

                </Row>
                : null
            }
            <Row widths={["grid-7"]} spacingInset="small none none">
                <Table headerRows={1} showDividers={false} spacing="small">
                    {/* CART TABLE MAIN HEADER */}
                    <TableRow>
                        <TableCell/>
                        <TableCell>
                            <FormattedMessage id="cartContent.location" defaultMessage="Location"/>
                        </TableCell>
                        {!props.container.isNotOVCart ?
                            <TableCell>
                                <FormattedMessage id="cartContent.picked" defaultMessage="Picked"/>
                            </TableCell>
                            : null
                        }
                        {!props.container.isNotOVCart ?
                            <TableCell>
                                <FormattedMessage id="cartContent.stowed" defaultMessage="Stowed"/>
                            </TableCell>
                            : null
                        }
                        <TableCell>
                            <FormattedMessage id="cartContent.staged" defaultMessage="Staged"/>
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="cartContent.departed" defaultMessage="Departed"/>
                        </TableCell>
                    </TableRow>

                    {/* CART TABLE BAG SECTION HEADER */}
                    {props.container.bags.length > 0 ? (
                        <TableSectionHeader><FormattedMessage id="pick.bags"
                                                              defaultMessage="Bags"/>: {props.container.bags.length}
                        </TableSectionHeader>
                    ) : null}

                    {/* CART TABLE BAG ROWS */}
                    {props.container.bags.map(bag => (
                        <TableRow key={bag.label}>
                            <TableCell>
                                {bag.label}
                            </TableCell>
                            <TableCell>{bag.location}</TableCell>
                            {!props.container.isNotOVCart ?
                                <TableCell>
                                    <Text>
                                        {bag.picked ? <Icon className="picked-success" tokens={check}/> :
                                            <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                    </Text>
                                </TableCell>
                                : null
                            }
                            <TableCell>
                                <Text>
                                    {bag.staged ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {bag.departed ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                </Text>
                            </TableCell>
                        </TableRow>
                    ))}

                    {/* CART TABLE PACKAGE SECTION HEADER */}
                    {props.container.packages.length > 0 ? (
                        <TableSectionHeader><FormattedMessage id="pick.packages"
                                                              defaultMessage="Packages"/>: {props.container.packages.length}
                        </TableSectionHeader>
                    ) : null}

                    {/* CART TABLE PACKAGE ROWS */}
                    {props.container.packages.map(packages => (
                        <TableRow key={packages.label}>
                            <TableCell>
                                {packages.label}
                            </TableCell>
                            <TableCell>{packages.location}</TableCell>
                            {!props.container.isNotOVCart ?
                                <TableCell>
                                    <Text>
                                        {packages.picked ? <Icon className="picked-success" tokens={check}/> :
                                            <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                    </Text>
                                </TableCell>
                                : null
                            }
                            {!props.container.isNotOVCart ?
                                <TableCell>
                                    <Text>
                                        {packages.stowed ? <Icon className="picked-success" tokens={check}/> :
                                            <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                    </Text>
                                </TableCell>
                                : null
                            }
                            <TableCell>
                                <Text>
                                    {packages.staged ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {packages.departed ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/>}
                                </Text>
                            </TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Row>
        </div>
    );
}

export default CartContent


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/CartContent.js